module.exports = __webpack_public_path__ + "img/spartan-contact-square.d5bfeb7d.jpg";